// extracted by mini-css-extract-plugin
export default {"root":"Search_root__UedR6","input":"Search_input__YQJNl","pizzaIcon":"Search_pizzaIcon__cZqHv","clearIcon":"Search_clearIcon__-LO61"};